export const newLoanConstants = {
    FIND_AN_OFFICE_REQUEST: 'FIND_AN_OFFICE_REQUEST',
    FIND_AN_OFFICE_SUCCESS: 'FIND_AN_OFFICE_SUCCESS',
    FIND_AN_OFFICE_FAILURE: 'FIND_AN_OFFICE_FAILURE',

    NEW_LOAN_APP_LOGGED_IN_REQUEST: 'NEW_LOAN_APP_LOGGED_IN_REQUEST',
    NEW_LOAN_APP_LOGGED_IN_FAILURE: 'NEW_LOAN_APP_LOGGED_IN_REQUEST',

    NEW_LOAN_APP_REQUEST: "NEW_LOAN_APP_REQUEST",
    NEW_LOAN_APP_SUCCESS: "NEW_LOAN_APP_SUCCESS",
    NEW_LOAN_APP_FAILURE: "NEW_LOAN_APP_FAILURE",

    NEW_LOAN_VALIDATION_FAIL: "NEW_LOAN_VALIDATION_FAIL",
    NEW_LOAN_VALIDATION_PASS: "NEW_LOAN_VALIDATION_PASS",

    NEW_LOAN_PERSONAL_INFORMATION_REQUEST: 'NEW_LOAN_PERSONAL_INFORMATION_REQUEST',
    NEW_LOAN_PERSONAL_INFORMATION_FAILURE: 'NEW_LOAN_PERSONAL_INFORMATION_FAILURE _FAILURE',

    NEW_LOAN_FINANCIAL_INFORMATION_REQUEST: 'NEW_LOAN_FINANCIAL_INFORMATION_REQUEST',
    NEW_LOAN_FINANCIAL_INFORMATION_FAILURE: 'NEW_LOAN_FINANCIAL_INFORMATION_FAILURE',

    NEW_LOAN_FUNDING_REQUEST: 'NEW_LOAN_FUNDING_REQUEST',
    NEW_LOAN_FUNDING_FAILURE: 'NEW_LOAN_FUNDING_FAILURE',

    PERSONAL_INFORMATION_REQUEST: 'PERSONAL_INFORMATION_REQUEST',
    PERSONAL_INFORMATION_SUCCESS: 'PERSONAL_INFORMATION _SUCCESS',
    PERSONAL_INFORMATION_FAILURE: 'PERSONAL_INFORMATION _FAILURE',
    
    FINANCIAL_INFORMATION_REQUEST: 'FINANCIAL_INFORMATION_REQUEST',
    FINANCIAL_INFORMATION_SUCCESS: 'FINANCIAL_INFORMATION_SUCCESS',
    FINANCIAL_INFORMATION_FAILURE: 'FINANCIAL_INFORMATION_FAILURE',

    NEW_LOAN_AMOUNT_REQUEST: 'NEW_LOAN_AMOUNT_REQUEST',
    NEW_LOAN_AMOUNT_FAILURE: 'NEW_LOAN_AMOUNT_FAILURE',

    NEW_LOAN_AMOUNT_BACK_REQUEST: 'NEW_LOAN_AMOUNT_BACK_REQUEST',
    NEW_LOAN_AMOUNT_BACK_FAILURE: 'NEW_LOAN_AMOUNT_BACK_FAILURE',

    CONFIRMATION_SUMMARY_REQUEST: 'CONFIRMATION_SUMMARY_REQUEST',
    CONFIRMATION_SUMMARY_SUCCESS: 'CONFIRMATION_SUMMARY_SUCCESS',
    CONFIRMATION_SUMMARY_FAILURE: 'CONFIRMATION_SUMMARY_FAILURE',

    APPLICATION_CONFIRMATION_REQUEST: "APPLICATION_CONFIRMATION_REQUEST",
    APPLICATION_CONFIRMATION_SUCCESS: "APPLICATION_CONFIRMATION_SUCCESS",
    APPLICATION_CONFIRMATION_FAILURE: "APPLICATION_CONFIRMATION_FAILURE",

    PRE_APPROVAL_REQUEST: "PRE_APPROVAL_REQUEST",
    PRE_APPROVAL_SUCCESS: "PRE_APPROVAL_SUCCESS",

    NEW_LOAN_UPLOAD_TOKEN_FAILURE: "NEW_LOAN_UPLOAD_TOKEN_FAILURE",

    NEW_LOAN_TOKEN_SUCCESS: "NEW_LOAN_TOKEN_SUCCESS",
    NEW_LOAN_TOKEN_FAILURE: "NEW_LOAN_TOKEN_FAILURE",

    ACCOUNT_NOT_FOUND: "ACCOUNT_NOT_FOUND",

    SET_WORKING: "SET_WORKING",

    VALIDATE_STATE_FAILURE: "VALIDATE_STATE_FAILURE",
    VALIDATE_STATE_SUCCESS: "VALIDATE_STATE_SUCCESS",

    NEW_LOAN_UNEXPECTED_ERROR: "NEW_LOAN_UNEXPECTED_ERROR",

    SEND_NOTIFICATION_EMAIL_REQUEST: "SEND_NOTIFICATION_EMAIL_REQUEST",
    
    PERSONAL_INFO_ERROR_CHECK: "PERSONAL_INFO_ERROR_CHECK",

    MAX_REQUEST_AMOUNT: "999999",
    MAX_MONTHLY_RESIDENCE_PAYMENT: "999999",
    MAX_INCOME_AMOUNT: "999999"
};



// WEBPACK FOOTER //
// ./src/_constants/newloan.constants.js